import { render, staticRenderFns } from "./riskEvaluation.vue?vue&type=template&id=64819cd4&scoped=true"
import script from "./riskEvaluation.vue?vue&type=script&lang=js"
export * from "./riskEvaluation.vue?vue&type=script&lang=js"
import style0 from "./riskEvaluation.vue?vue&type=style&index=0&id=64819cd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64819cd4",
  null
  
)

export default component.exports